export const actionConst = {
    OPEN_INVOICE_MODAL: 'OPEN_INVOICE_MODAL',
    CLOSE_INVOICE_MODAL: 'CLOSE_INVOICE_MODAL',
};
